// extracted by mini-css-extract-plugin
module.exports = {"backButton":"styles_backButton__Y8NHr","white":"styles_white__3bfFv","container":"styles_container__24bYZ"};